import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const UnitPriceConfirmation = ({ onClose, onSave }) => {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      sx={{
        zIndex: 3000,
      }}
    >
      <DialogTitle>Confirm Price Change</DialogTitle>

      <DialogContent>
        Changing unit prices will impact{" "}
        <strong>all active subscriptions</strong>. Are you sure you want to
        continue?
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>

        <Button onClick={onSave} color="error" variant="contained">
          Yes, Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnitPriceConfirmation;
